import React from 'react'

interface IFilterBadge {
  filterKey: string
  activeTab: string
  handleSelect: (string) => void
  label: string | JSX.Element
}

export default function FilterBadge(props: IFilterBadge) {
  const { label, filterKey, activeTab, handleSelect } = props

  return (
    <div
      onClick={() => handleSelect(filterKey)}
      className={`badge gap-2 px-4 py-2 cursor-pointer h-6 ${
        activeTab == filterKey && `badge-primary text-white`
      }`}
    >
      <p className='text-xs text-center'>{label}</p>
    </div>
  )
}
